import { render } from "./UpcomingOrders.vue?vue&type=template&id=1714b8a0"
import script from "./UpcomingOrders.vue?vue&type=script&lang=js"
export * from "./UpcomingOrders.vue?vue&type=script&lang=js"

import "./UpcomingOrders.vue?vue&type=style&index=0&id=1714b8a0&lang=css"

import exportComponent from "/codebuild/output/src396721354/src/serverlesspressoV3/frontends/vue-display-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__